import { useState } from 'react';
import {
  Button,
  ButtonAlignment,
  ButtonSize,
  ButtonStyles,
  ButtonWidth,
  Checkbox,
  Modal,
  TextLink,
  TextLinkStyle,
  Theme,
  useTranslation,
} from '@nextgen-web-framework/all';
import { InitialCartState, updateIsCheckoutDisabled } from '@commerce-cart-webcomponents/sdk';
import { useSelector, useDispatch } from 'react-redux';
import type { AppState } from '@nextgen-web-framework/core';
import { useFetchCmsContent } from '../../../common';
import styles from './KitTermsAndConditions.module.scss';

const KitTermsAndConditions = () => {
  const { isCheckoutDisabled }: InitialCartState = useSelector((state: AppState) => state.commerceCart);
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);
  const [showChecked, setShowChecked] = useState<boolean>(!isCheckoutDisabled);
  const dispatch = useDispatch();
  const t = useTranslation();
  const cmsData = useFetchCmsContent();
  const checkboxText = t('cart.KitTermsAndConditions.termsAndCondtions');

  const onCheckboxClick = () => {
    if (!showChecked) {
      setShowTermsModal(true);
      return;
    }
    setShowChecked(false);
    dispatch(updateIsCheckoutDisabled(true));
  };

  return (
    <div className={styles['checkbox-container']}>
      <Checkbox
        text={
          <div
            role="checkbox"
            tabIndex={0}
            aria-checked={showChecked}
            className={styles['acceptance-checkbox']}
            onClick={(event: React.MouseEvent | React.KeyboardEvent) => {
              event.preventDefault();
            }}
            onKeyDown={(event: React.KeyboardEvent) => {
              event.preventDefault();
            }}
          >
            {t('cart.KitTermsAndConditions.iAcceptTerms')} &nbsp;
            <TextLink
              text={checkboxText}
              scroll={false}
              onClick={() => setShowTermsModal(true)}
              theme={Theme.PURPLE}
              textLinkStyle={TextLinkStyle.UNDERLINE}
            />
          </div>
        }
        checked={showChecked}
        onClick={onCheckboxClick}
      />
      {showTermsModal && (
        <Modal
          buttonAlignment={ButtonAlignment.VERTICAL}
          closeIcon={true}
          onClose={() => setShowTermsModal(false)}
          primaryButtonLabel={''}
          headline={cmsData ? (cmsData?.kit_terms_and_conditions?.title as string) : ''}
        >
          <div className={styles['terms-modal-container']}>
            <div
              className={styles['terms-modal-container-heading']}
              dangerouslySetInnerHTML={{
                __html: cmsData ? (cmsData?.kit_terms_and_conditions?.description as string) : '',
              }}
            />
            {!showChecked && (
              <div className={styles['agree-button-container']}>
                <Button
                  title={t('cart.KitTermsAndConditions.iAgree')}
                  buttonStyle={ButtonStyles.SOLID}
                  buttonWidth={ButtonWidth.FULL_WIDTH}
                  size={ButtonSize.MEDIUM}
                  data-testid="agree-btn"
                  onClick={() => {
                    setShowTermsModal(false);
                    setShowChecked(true);
                    dispatch(updateIsCheckoutDisabled(false));
                  }}
                  aria-label={t('cart.KitTermsAndConditions.iAgree')}
                />
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

export { KitTermsAndConditions };
